export default (id, _name, options) => {
    $(`#wrapper_${id}`).find('.toggle-holder').click(function() {
        $(this).toggleClass('active');
        let chevron = $(this).find('i');
        chevron.toggleClass('fa-chevron-left');
        chevron.toggleClass('fa-chevron-right');
        $(options.target).toggleClass('hidden');
        $(window).trigger('resize');
    });
}
